export const HMDBLink = (hmdb) => <a href={"https://hmdb.ca/metabolites/" + hmdb.value} target="_blank" rel="noopener noreferrer"> {hmdb.value} </a>
